import client from '../ApolloClient'
import gql from 'graphql-tag'
import {
  FETCH_SEARCH_USERS,
  FETCH_SEARCH_CONTENT,
  loadSearchResults,
  LOAD_SEARCH_CONTENT,
  LOAD_SEARCH_USERS
} from '../Actions/Search'
import { failFetch } from '../Actions/Other'
// eslint-disable-next-line
import { Observable, Subject, filter, mergeMap, map, takeUntil } from 'rxjs';

export const searchItemsAnalyticsQuery = gql`query getSearchItemsAnalytics($accountId: ID!, $limit: Int, $offset: Int, $appProfileIds: [ID!], $groupIds: [ID!], $searchTerm: String!, $searchType: SearchType!, $userType: String!) {
        getSearchItemsAnalytics(accountId: $accountId, limit: $limit, offset: $offset, appProfileIds: $appProfileIds, groupIds: $groupIds, searchTerm: $searchTerm, searchType: $searchType, userType: $userType)
        {
          searchItemsResult {
            _id
            label
            itemType
          }
          type
        }
      }`

/**
  * searchEpic
  * @desc action Observer that sends a query and processes result if the action is a fetch content action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const searchEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_SEARCH_CONTENT || action.type === FETCH_SEARCH_USERS),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: searchItemsAnalyticsQuery, variables: { ...action.query } })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            let type = LOAD_SEARCH_CONTENT
            if (action.type === FETCH_SEARCH_USERS) {
              type = LOAD_SEARCH_USERS
            }
            return loadSearchResults(type, response.data)
          } else {
            return failFetch(response)
          }
        }),
        takeUntil(action$.pipe(
          filter(action2 => action2.type === FETCH_SEARCH_CONTENT))
        )
      )
    })
  )

// const searchUsersAnalyticsQuery = gql`query searchUsersAnalytics($searchTerm: String) {
//   searchUsersAnalytics(searchTerm: $searchTerm) {
//     users {
//       _id
//       name
//     }
//     count
//   }
// }`
//
// /**
//   * searchUsersEpic
//   * @desc action Observer that sends a query and processes result if its a fetch top folder action
//   * @param {Observable<action>} action$ Action Observable stream
//   * @return {action}
// */
// export const searchUsersEpic = action$ =>
//   action$.filter(action => action.type === FETCH_SEARCH_USERS)
//     .switchMap(action => {
//       const subject = new Subject()
//       client.query({ query: searchUsersAnalyticsQuery, variables: { ...action.query } })
//         .then((data) => { subject.next(data) })
//         .catch((error) => {
//           subject.next(error)
//         })
//       return subject.map((response) => {
//         if (response.data) {
//           return loadSearchUsers(response.data)
//         } else {
//           let error
//           if (response.graphQLErrors) {
//             error = response.graphQLErrors[0]
//           } else if (!error && response.networkError) {
//             error = response.networkError.result.errors[0]
//           } else {
//             error = response
//           }
//           return failFetch(error)
//         }
//       })
//     })
